import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import colorSwatchColorMap from '@maps/components/color-swatch-color-map';
import styles from './hot-filter-option-item.module.scss';

interface HotFilterOptionItemInterface {
  checked: boolean;
  label: React.JSX.Element | string;
  htmlId: string;
  disabled?: boolean;
  onChange: (event: Event) => void;
  customLabelClass?: string;
  identifier?: string;
  childId?: string;
  dataCy?: string;
}

type HotFilterOptionItemProps = HotFilterOptionItemInterface & Omit<React.HTMLProps<HTMLDivElement>, 'label'>;

const HotFilterOptionItem: React.FC<HotFilterOptionItemProps> = (props): React.JSX.Element => {
  const {
    label,
    checked = false,
    onChange,
    htmlId,
    disabled,
    customLabelClass = '',
    identifier,
    childId,
    dataCy,
  } = props;

  const [checkedState, setCheckedState] = useState<boolean>(checked);

  const handleChange = (event) => {
    onChange(event);
    setCheckedState(event.target.checked);
  };

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  const swatchColor = colorSwatchColorMap(childId as string);

  return (
    <div className={styles.hotFilterOptionItem}>
      <input
        name="checkItem"
        type="checkbox"
        disabled={disabled}
        checked={checkedState}
        onChange={handleChange}
        id={htmlId}
        className={clsx(styles.hotFilterOptionItem__input, 'vc-checkbox__input', 'vc-form-checkboxInput')}
        data-cy={dataCy ?? `${identifier}-input${checkedState ? '-checked' : ''}`}
      />
      <label
        htmlFor={htmlId}
        className={clsx(
          styles.hotFilterOptionItem__label,
          customLabelClass,
          checkedState && styles['hotFilterOptionItem__label--selected'],
          'vc-form-checkboxLabel',
        )}
        data-cy={`${identifier}-label${checkedState ? '-checked' : ''}`}
      >
        {swatchColor && (
          <span
            className={clsx(
              { [styles.hotFilterOptionItem__label__icon]: swatchColor },
              { [styles['hotFilterOptionItem__label__icon--hasBorder']]: swatchColor },
            )}
            style={{
              ...(swatchColor && !swatchColor.assetUrl ? { backgroundColor: swatchColor.hexadecimal } : {}),
            }}
          >
            {swatchColor.assetUrl && (
              <img
                height={15}
                width={15}
                alt={typeof label === 'string' ? label : ''}
                src={swatchColor.assetUrl}
              />
            )}
          </span>
        )}
        <span className={styles.hotFilterOptionItem__label__name}>{label}</span>
        <span className={clsx(styles['vc-form-checkboxLabel__box'], 'vc-form-checkboxLabel__box')}></span>
      </label>
    </div>
  );
};

export default HotFilterOptionItem;
